// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__nUrec","spin":"styles_spin__3ODrb"};